import React from 'react'
import './Product_Specification.css'

const Product_Specification = (props) => {

    const specification1 = [
        {
            title: "Category ",
            subTitle: props?.product?.p_category?.name
        },
        {
            title: "Sub Category ",
            subTitle: props?.product?.p_sub_category?.name
        },
        {
            title: "Child Category ",
            subTitle: props?.product?.p_child_category?.name
        },
    ]

    const specification2 = [
        {
            title: "Seller ",
            subTitle: "Groscido"
        },
        {
            title: "Brand ",
            subTitle: props?.product?.Brand?.name
        },
        {
            title: "Manufacturer",
            subTitle: props?.product?.manufacturer
        },
    ]

    return (
        <div className='Product_Specification'>
            <h3>Product Specifications</h3>

            <div className='specification_div'>

                <div className='row'>
                    <div className='col-xl-6 col-lg-12 col-md-12 col-sm-12'>
                        {specification1?.map((item) => {
                            return (
                                <div className='row' >
                                    <div className='col-lg-7 col-md-7 col-sm-5 col-6'>
                                        <div className='title'>
                                            <p>{item?.title ||"-"}</p><span>:</span>
                                        </div>
                                    </div>

                                    <div className='col-lg-5 col-md-5 col-sm-6 col-6'>
                                        <div className='subTitle'>
                                            <p>{item?.subTitle ||"-"}</p>
                                        </div>
                                    </div>
                                </div>

                            )
                        })}
                    </div>

                    <div className='col-xl-6 col-lg-12 col-md-12 col-sm-12'>
                        {specification2?.map((item) => {
                            return (
                                <div className='row' >
                                    <div className='col-lg-7 col-md-7 col-sm-5 col-6'>
                                        <div className='title'>
                                            <p>{item?.title ||"-"}</p><span>:</span>
                                        </div>
                                    </div>

                                    <div className='col-lg-5 col-md-5 col-sm-6 col-6'>
                                        <div className='subTitle'>
                                            <p>{item?.subTitle||"-"}</p>
                                        </div>
                                    </div>
                                </div>

                            )
                        })}
                    </div>
                </div>



            </div>
        </div >
    )
}

export default Product_Specification
